// Canonical URL catalogue: page titles, normalized paths, and SEO metadata.
import { ASSETS } from './assets';
import { buildContentPageRoutes } from '../content/queries';
/** Fallback SEO applied when a route has no inline `seo` block. */
export const DEFAULT_PAGE_SEO = {
    title: 'Airhead Games',
    description: 'Party games for streamers, shaped by the people who play them. Fresh every session and frictionless to join.',
    image: ASSETS.ogImage,
    imageWidth: 1200,
    imageHeight: 630,
};
const contentPageRoutes = buildContentPageRoutes();
export const pageRoutes = [
    // Home
    {
        path: '/',
        normalizedPath: '/',
        pageTitle: 'Home',
        seo: {
            title: 'Airhead Games',
            description: 'Party games for streamers. Games shaped by the people who play them, fresh every session and frictionless to join.',
        },
    },
    // Play
    {
        path: '/library',
        normalizedPath: '/library',
        pageTitle: 'Game Library',
        seo: {
            description: 'Which game to play next? Our library of party games is always growing. Every turn generates fresh content for your stream, so no two sessions are ever the same.',
        },
    },
    {
        path: '/library/poppy',
        normalizedPath: '/library/poppy',
        pageTitle: 'Host Style',
        seo: {
            description: "Customize Poppy's voice, accent, and personality for the next room you host.",
        },
    },
    {
        path: '/library/achievements',
        normalizedPath: '/library/achievements',
        pageTitle: 'Achievements',
        seo: {
            description: 'Earn Loons for what you do on Airhead Games. See every achievement, track your progress toward the next reward, and review the levels you have earned.',
        },
    },
    {
        // Unreleased and deliberately absent from sitemap.xml and llms.txt.
        path: '/world',
        normalizedPath: '/world',
        pageTitle: 'World',
        index: false,
        seo: {
            description: 'Explore the Airhead world. Wander the hub, visit the places our games come from, and see what is being built.',
        },
    },
    {
        path: '/join',
        normalizedPath: '/join',
        pageTitle: 'Join Room',
        seo: {
            description: 'Join a game room instantly. Enter a room code and start playing. No account or download needed. Fun starts in seconds.',
        },
    },
    {
        path: '/room/:roomCode',
        normalizedPath: '/room',
        pageTitle: 'Room',
        index: false,
        seo: {
            description: 'Your game room is ready. Share the room code with players and let the fun begin.',
        },
    },
    {
        path: '/room/:roomCode/player',
        normalizedPath: '/player',
        pageTitle: 'Room-Player',
        index: false,
        seo: {
            title: 'Join Game',
            description: 'Customize your player avatar and join the fun. Pick your game face, choose your color, and get ready to play.',
        },
    },
    {
        path: '/game/:roomCode',
        normalizedPath: '/game',
        pageTitle: 'Game',
        index: false,
        seo: {
            description: 'Game in progress. Experience personalized party games like never before as Poppy weaves your group into the action.',
        },
    },
    {
        path: '/game/:roomCode/playing',
        normalizedPath: '/playing',
        pageTitle: 'Game-Playing',
        index: false,
        seo: {
            title: 'Playing',
            description: 'You are in the game. Experience personalized party games as Poppy calls you out and riffs on your answers.',
        },
    },
    // Party Central uses a bespoke explorer, not a generated content route.
    {
        path: '/party-central',
        normalizedPath: '/party-central',
        pageTitle: 'Party Central',
        seo: {
            title: 'Party Central: Twitch Party Game Data',
            description: 'Explore Twitch party-game streaming data, compare games and streamers, track trends, inspect Party Scores, and read monthly reports from Airhead Games.',
        },
    },
    // Canonical document and collection routes
    ...contentPageRoutes,
    // Legacy discover surfaces that are not part of the document refactor yet.
    {
        path: '/discover/music',
        normalizedPath: '/discover/music',
        pageTitle: 'Discover Our Music',
        seo: {
            description: 'Explore the Airhead Games music catalog with original artists, albums, and songs created for our games.',
        },
    },
    {
        path: '/discover/campaigns',
        normalizedPath: '/discover/campaigns',
        pageTitle: 'Discover Campaigns',
        seo: {
            description: 'Check out special campaigns and limited-time events from Airhead Games. Discover exciting opportunities to play and earn rewards.',
        },
    },
    {
        path: '/discover/clips',
        normalizedPath: '/discover/clips',
        pageTitle: 'Discover Clips',
        seo: {
            description: 'Watch clips from streamers playing Airhead Games. See funny moments, player reactions, and what makes our party games so entertaining.',
        },
    },
    {
        path: '/blog/category/:tag',
        normalizedPath: '/blog/category',
        pageTitle: 'Blog Category',
        index: false,
    },
    // Unlisted: publicly reachable but not indexed or linked from nav
    {
        path: '/draw',
        normalizedPath: '/draw',
        pageTitle: 'Draw',
        index: false,
        seo: {
            title: 'Draw',
            description: 'Sketch on the Airhead Games drawing board and send Poppy your masterpiece.',
        },
    },
    {
        path: '/scan',
        normalizedPath: '/scan',
        pageTitle: 'Scan',
        seo: {
            title: 'You Scanned Airhead Games',
            description: 'You found Airhead Games. Discover party games that are fresh every session and frictionless for players to join.',
        },
    },
    {
        path: '/faqs',
        normalizedPath: '/faqs',
        pageTitle: 'FAQs',
        seo: {
            description: 'Find answers about Airhead Games, including pricing, gameplay, login options, streaming features, player access, and more.',
        },
    },
    {
        path: '/pricing',
        normalizedPath: '/pricing',
        pageTitle: 'Pricing',
        seo: {
            description: 'Start hosting party games for free in your browser, then buy more game credits when you need them.',
        },
    },
];
//# sourceMappingURL=pageRoutes.js.map